import {usePlantRunningTimes} from '@domain/running-times'
import {useUpmPlantTimezone} from '@hconnect/upm'
import {CircularProgress} from '@mui/material'
import {useEffect} from 'react'
import {useNavigate} from 'react-router'

import {RouteSegment} from '../consts'
import {useStoppageAnalysisDateRange} from '../hooks'

export const DefaultEquipmentRedirect = ({plantId}: {plantId: string}) => {
  const timezone = useUpmPlantTimezone(plantId)
  const {from, to} = useStoppageAnalysisDateRange({timezone})
  const navigate = useNavigate()

  const {
    data,
    isLoading: isLoadingRunningTimes,
    isError
  } = usePlantRunningTimes({plantId, from: from.toISOString(), to: to.toISOString()})

  const firstEquipmentId = data?.[0]?.equipment.id

  useEffect(() => {
    if (firstEquipmentId) {
      void navigate(`${RouteSegment.EQUIPMENT}/${firstEquipmentId}`, {replace: true})
    }
  }, [navigate, firstEquipmentId])

  if (isLoadingRunningTimes) {
    return <CircularProgress color="secondary" size={80} />
  }

  if (isError) {
    throw new Error('Error fetching running times')
  }

  if (!firstEquipmentId) {
    throw new Error('No equipment found for this plant')
  }

  return null
}
